import SiteHeader from '../components/SiteHeader';
import demoJobs from '../data/demoJobs.json';

function formatWhen(iso) {
  if (!iso) return '—';
  try {
    return new Date(iso).toLocaleString();
  } catch {
    return iso;
  }
}

function StatusBadge({ status }) {
  return <span className={`status-badge status-${status}`}>{status}</span>;
}

export default function JobsPage() {
  const counts = demoJobs.reduce((acc, job) => {
    acc[job.status] = (acc[job.status] || 0) + 1;
    return acc;
  }, {});

  return (
    <div className="site-page site-page-app">
      <SiteHeader variant="app" />
      <div className="demo-banner">
        Dummy job history — in production, jobs are executed by QGIS Processing.
      </div>

      <main className="demo-page">
        <header className="demo-page-head">
          <div>
            <h1>Jobs</h1>
            <p className="field-hint">Sample runs from the interactive demo (not live).</p>
          </div>
          <div className="job-stat-pills">
            <span className="job-stat-pill">{counts.completed || 0} completed</span>
            <span className="job-stat-pill is-running">{counts.running || 0} running</span>
            <span className="job-stat-pill is-pending">{counts.pending || 0} pending</span>
            <span className="job-stat-pill is-failed">{counts.failed || 0} failed</span>
          </div>
        </header>

        <div className="jobs-table-wrap panel-card">
          <table className="jobs-table">
            <thead>
              <tr>
                <th>Job</th>
                <th>Status</th>
                <th>Started</th>
                <th>Duration</th>
                <th>Features</th>
                <th>User</th>
              </tr>
            </thead>
            <tbody>
              {demoJobs.map((job) => (
                <tr key={job.id}>
                  <td>
                    <strong>{job.name}</strong>
                    <div className="jobs-table-id">{job.id} · {job.algorithmId}</div>
                    {job.error ? <div className="jobs-table-error">{job.error}</div> : null}
                  </td>
                  <td><StatusBadge status={job.status} /></td>
                  <td>{formatWhen(job.startedAt)}</td>
                  <td>{job.duration}</td>
                  <td>{job.features ?? '—'}</td>
                  <td>{job.user}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </main>
    </div>
  );
}
